<template>
  <div class="content">
    <h1 class="has-text-centered">Die Seite wurde nicht gefunden</h1>
    <div class="box">
      <p>
        Leider konnte die gesuchte Seite nicht gefunden werden.
      </p>
      <p>
        <router-link :to="{name: 'start'}">HIER</router-link> gehts zurück zur Startseite.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ee-page-not-found',
  metaInfo: {
    title: 'Seite wurde nicht gefunden',
    meta: [
      {
        name: 'prerender-status-code',
        content: '404'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: 'Elektrotechnik-Rechner.at', route: 'start' })
  }
}
</script>
